import { gql } from '@apollo/client'

export const signUp = gql`
  mutation SignUp($data: SignUpInput!) {
    signUp(data: $data)
  }
`

export const requestPasswordReset = gql`
  mutation RequestPasswordReset($data: BasicEmailInput!) {
    requestPasswordReset(data: $data)
  }
`

export const resetPassword = gql`
  mutation ResetPassword($data: ResetPasswordInput!) {
    resetPassword(data: $data)
  }
`

export const updatePassword = gql`
  mutation UpdatePassword($data: UpdatePasswordInput!) {
    updatePassword(data: $data)
  }
`

export const addNewEmail = gql`
  mutation AddNewEmail($data: AddEmailInput!) {
    addNewEmail(data: $data) {
      id
      confirmationToken
    }
  }
`

export const confirmAddedEmail = gql`
  mutation confirmAddedEmail($data: String!) {
    confirmAddedEmail(data: $data) {
      id
    }
  }
`

export const updateEmail = gql`
  mutation updateEmail($data: ChangeEmailInput!) {
    updateEmail(data: $data) {
      id
      email
    }
  }
`

export const deactivateEmail = gql`
  mutation deactivateEmail($data: DeactivateEmailInput!) {
    deactivateEmail(data: $data) {
      id
      email
    }
  }
`

export const confirmEmail = gql`
  mutation confirmEmail($data: EmailConfirmationInput!) {
    confirmEmail(data: $data)
  }
`

export const updateFirstLogin = gql`
  mutation updateFirstLogin($data: Boolean!) {
    updateFirstLogin(data: $data)
  }
`

export const updateProfile = gql`
  mutation updateProfile($data: UpdateProfileInput!) {
    updateProfile(data: $data) {
      id
      firstName
      lastName
      middleInitials
      phone
    }
  }
`

export const updateProfileWithoutAddress = gql`
  mutation updateProfile($data: UpdateProfileInput!) {
    updateProfile(data: $data) {
      id
      firstName
      lastName
      middleInitials
      phone
    }
  }
`

export const favouriteACharity = gql`
  mutation favouriteACharity($charityId: String!) {
    favouriteACharity(charityId: $charityId) {
      id
    }
  }
`

export const unfavouriteACharity = gql`
  mutation unfavouriteACharity($charityId: String!) {
    unfavouriteACharity(charityId: $charityId) {
      id
    }
  }
`

export const charityUserSignUp = gql`
  mutation charityUserSignUp($data: CharityUserSignUpInput!) {
    charityUserSignUp(data: $data)
  }
`

export const guestSignUp = gql`
  mutation guestSignUp($data: GuestSignUpInput!) {
    guestSignUp(data: $data)
  }
`

export const updateGuestProfile = gql`
  mutation updateGuestProfile($userId: Float!, $data: UpdateProfileInput!) {
    updateGuestProfile(userId: $userId, data: $data) {
      id
      firstName
      lastName
      middleInitials
      phone
    }
  }
`

export const requestAccountDeletion = gql`
  mutation requestAccountDeletion {
    requestAccountDeletion
  }
`

export const deleteMyAccount = gql`
  mutation DeleteMyAccount {
    deleteMyAccount
  }
`

export const closeMyAccount = gql`
  mutation CloseMyAccount {
    closeMyAccount
  }
`

export const closeMyPortal = gql`
  mutation CloseMyPortal($fundProfileId: Int!) {
    closeMyPortal(fundProfileId: $fundProfileId)
  }
`

export const requestGivingOptionsInfo = gql`
  mutation RequestGivingOptionsInfo(
    $email: String!
    $fundId: Float
    $options: [String!]!
    $isDonatingToFund: Boolean!
    $donationTargetName: String!
    $donationTargetId: String!
  ) {
    requestGivingOptionsInfo(
      email: $email
      fundId: $fundId
      options: $options
      isDonatingToFund: $isDonatingToFund
      donationTargetName: $donationTargetName
      donationTargetId: $donationTargetId
    )
  }
`

export const updateAdvisorCustodianSettings = gql`
  mutation UpdateAdvisorCustodianSettings($data: AdvisorCustodianSettingsInput!) {
    updateAdvisorCustodianSettings(data: $data) {
      custodianName
      advisorName
      advisorEmail
      advisorPhone
      advisorDealerRepCode
      address {
        lineOne
        city
        province
        postalCode
      }
    }
  }
`

export const updateMyAdvisorPortalName = gql`
  mutation UpdateMyAdvisorPortalName($fundProfileId: Int!, $portalName: String!) {
    updateMyAdvisorPortalName(fundProfileId: $fundProfileId, portalName: $portalName)
  }
`

export const updateTableColumnPreferences = gql`
  mutation UpdateTableColumnPreferences($data: UpdateTableColumnPreferencesInput!) {
    updateTableColumnPreferences(data: $data)
  }
`

export const resetTableColumnPreferences = gql`
  mutation ResetTableColumnPreferences($tableId: String!) {
    resetTableColumnPreferences(tableId: $tableId)
  }
`
